import React from 'react';
import ProductCard from './product-card';
import { ProductCardData } from '../types';

interface ProductsGridProps {
  products: ProductCardData[];
}

const ProductsGrid: React.FC<ProductsGridProps> = ({ products }) => {
  return (
    <div className="flex flex-wrap w-full xl:w-2/3 lg:w-2/3 sm:mt-8 md:justify-center">
      {products.map((product) => (
        <ProductCard key={product.id} product={product} className={'m-4'} />
      ))}
    </div>
  );
};

export default ProductsGrid;
